export default __webpack_public_path__ + "static/floor3-slide-1-400b18a7f6e3ab3a9e6fe78829add075.jpg";